module.exports = __webpack_public_path__ + "img/Directions.c7f3ada0.svg";